import { features } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="text-xl md:text-2xl font-black text-foreground-900">平台特色</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group flex flex-col items-center text-center gap-3 p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-accent-100 group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-800">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}